import { Navigate, useLocation } from "react-router-dom";
import { useAgencyAuth } from "../../contexts/AgencyAuthContext/AgencyAuthContext";
import { LoadingScreen } from "../common/LoadingScreen";

interface AgencyProtectedRouteProps {
  children: React.ReactNode;
}

export const AgencyProtectedRoute = ({
  children,
}: AgencyProtectedRouteProps) => {
  const { user, isLoading } = useAgencyAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!user || user.role !== "AGENCY") {
    return (
      <Navigate to="/agency/auth/login" state={{ from: location }} replace />
    );
  }

  return <>{children}</>;
};
